import React, { useEffect } from 'react';
import { Chart, registerables } from 'chart.js';
import { Order } from 'core/domains/order';
import OverviewBox from 'components/overview-box/overview-box';
import './order-pie-chart.scss';

// Register all components
Chart.register(...registerables);


// Define the props for the component
interface OrderPieChartProps {
    orders: Order[]; // Array of orders
}

const OrderPieChartByTypes: React.FC<OrderPieChartProps> = ({ orders }) => {
    const chartRef = React.useRef<Chart | null>(null); // Reference for the chart instance

    useEffect(() => {
        // Count the occurrences of each order type
        const orderCounts = orders.reduce<Record<string, number>>((acc, order: Order) => {
            acc[order.orderType.title] = (acc[order.orderType.title] || 0) + 1;
            return acc;
        }, {});

        // Prepare the data for the pie chart
        const data = {
            labels: Object.keys(orderCounts),
            datasets: [{
                data: Object.values(orderCounts),
                backgroundColor: ['rgba(75, 192, 75, 0.6)', 'rgba(75, 75, 192, 0.6)'],
                hoverBackgroundColor: ['rgba(75, 192, 75, 0.8)', 'rgba(75, 75, 192, 0.8)'],
            }]
        };
        const totalAmount = Object.values(orderCounts).reduce((sum, amount) => sum + amount, 0);

        // Configuration for the pie chart
        const config = {
            type: 'doughnut',
            data: data,
            options: {
                responsive: true,
                plugins: {
                    legend: {
                        display: true,
                        position: 'top',
                        labels: {
                            font: {
                                family: 'YekanBakh', // Set font family for legend
                                size: 14, // Set font size for legend
                            },
                        },
                    },
                    tooltip: {
                        titleFont: {
                            family: 'YekanBakh', // Set font family for legend
                            size: 14, // Set font size for tooltip title
                        },
                        bodyFont: {
                            family: 'YekanBakh', // Set font family for legend
                            size: 12, // Set font size for tooltip body
                        },
                        callbacks: {
                            label: function (tooltipItem: any) {
                                const label = tooltipItem.label || '';
                                const value = tooltipItem.raw || 0;
                                return `${label}: ${value} سفارش`;
                            }
                        }
                    }
                }
            }
        };
        // Get the context of the canvas
        const ctx = document.getElementById('orderPieChart') as HTMLCanvasElement;

        // Destroy the previous chart instance if it exists
        if (chartRef.current) {
            chartRef.current.destroy();
        }

        // Create a new chart and store the reference
        chartRef.current = new Chart(ctx.getContext('2d') as CanvasRenderingContext2D, config as any);

        // Cleanup function to destroy the chart on component unmount
        return () => {
            if (chartRef.current) {
                chartRef.current.destroy();
            }
        };
    }, [orders]);

    const getTotalValueOfNewOrders = orders.length > 0 ? orders.filter(s => s.state.id == 2 && s.orderType.id == 0).reduce((accumulator, order) => {
        return accumulator + order.amount;
    }, 0) : 0;

    const getTotalValueOfExtendOrders = orders.length > 0 ? orders.filter(s => s.state.id == 2 && s.orderType.id == 1).reduce((accumulator, order) => {
        return accumulator + order.amount;
    }, 0) : 0;

    return (
        <div className='overview-piechart-orders'>
            <canvas id="orderPieChart" width="200" height="200"></canvas>
            <div className="order-types-info">
                <div className="row">
                    <OverviewBox
                        hideCount
                        title={'سفارش جدید'}
                        value={getTotalValueOfNewOrders}
                        count={orders.length > 0 ? orders.filter(s => s.state.id == 2 && s.orderType.id == 0).length : 0}
                    />
                    <OverviewBox
                        hideCount
                        title={'تمدید'}
                        value={getTotalValueOfExtendOrders}
                        count={orders.length > 0 ? orders.filter(s => s.state.id == 2 && s.orderType.id == 1).length : 0}
                    />
                </div>
            </div>
        </div>
    );
};


export default OrderPieChartByTypes;
